<template>
  <div class="content-v2">
    <div class="history-head">
      <span>DEVELOPMENT</span>
      <h2>{{ $t('common.history') }}</h2>
      <p>记录盛博莱从起步、成长到突破的关键节点。</p>
    </div>
    <div class="history-timeline">
      <div class="history-item" v-for="(item, index) in displayHistoryList" :key="item.id">
        <div class="history-year">{{ item.year }}</div>
        <div class="history-card">
          <div class="history-index">{{ String(index + 1).padStart(2, '0') }}</div>
          <div class="history-content">
            <h3>{{ item.title }}</h3>
            <p>{{ item.content }}</p>
          </div>
          <div v-if="item.image" class="history-image">
            <img :src="item.image" :alt="item.title" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHistoryList } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultImage from '@/assets/images/banner1.svg'

const fallbackHistory = [
  {
    id: 'fallback-1',
    year: '2020',
    title: '公司成立',
    content: '山东盛博莱电力工程有限公司成立，围绕电力技术服务领域建立专业团队，开启电力工程综合服务布局。',
    image: defaultImage
  },
  {
    id: 'fallback-2',
    year: '2023',
    title: '组织建设持续完善',
    content: '中共山东盛博莱电力工程有限公司支部委员会成立，公司组织管理、人才培养和项目交付体系进一步完善。',
    image: ''
  },
  {
    id: 'fallback-3',
    year: '2026',
    title: '综合服务能力突破',
    content: '围绕调试、维护、检修、电力试验、运行和油化实验室等专业方向，持续打造电力行业一站式综合服务平台。',
    image: ''
  }
]

export default {
  name: 'AboutHistoryV2',
  data() {
    return {
      historyList: fallbackHistory
    }
  },
  created() {
    getHistoryList().then(list => {
      if (!list || !list.length) {
        return
      }
      this.historyList = list.map(item => ({
        id: item.historyId,
        year: item.historyYear,
        title: item.historyTitle,
        content: item.historyContent,
        image: resolveFileUrl(item.imageUrl)
      }))
    }).catch(() => {})
  },
  computed: {
    displayHistoryList() {
      return this.historyList
    }
  }
}
</script>

<style lang="scss" scoped>
.history-head {
  margin-bottom: 42px;

  span {
    color: #2563eb;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 4px;
  }

  h2 {
    margin: 10px 0 12px;
    font-size: 34px;
    color: #0f172a;
  }

  p {
    font-size: 16px;
    line-height: 1.8;
    color: #64748b;
  }
}

.history-timeline {
  position: relative;
  padding-left: 116px;

  &::before {
    content: '';
    position: absolute;
    left: 78px;
    top: 14px;
    bottom: 14px;
    width: 1px;
    background: linear-gradient(to bottom, #2563eb, #dbeafe);
  }
}

.history-item {
  position: relative;
  margin-bottom: 28px;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: -47px;
    top: 28px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    border: 4px solid #2563eb;
    box-shadow: 0 0 0 8px rgba(37, 99, 235, 0.12);
  }
}

.history-year {
  position: absolute;
  left: -116px;
  top: 20px;
  width: 68px;
  font-size: 24px;
  font-weight: 800;
  color: #1d4ed8;
}

.history-card {
  display: grid;
  grid-template-columns: 70px minmax(0, 1fr) 220px;
  gap: 24px;
  align-items: center;
  padding: 28px;
  background: #fff;
  border: 1px solid #dbe7f5;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.06);
}

.history-index {
  font-size: 28px;
  font-weight: 800;
  color: rgba(37, 99, 235, 0.25);
}

.history-content {
  h3 {
    margin: 0 0 12px;
    font-size: 22px;
    color: #0f172a;
  }

  p {
    margin: 0;
    font-size: 16px;
    line-height: 1.9;
    color: #475569;
  }
}

.history-image {
  height: 130px;
  overflow: hidden;
  background: #f1f5f9;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

@media (max-width: 960px) {
  .history-timeline {
    padding-left: 0;

    &::before {
      display: none;
    }
  }

  .history-item::before {
    display: none;
  }

  .history-year {
    position: static;
    width: auto;
    margin-bottom: 10px;
  }

  .history-card {
    grid-template-columns: 1fr;
  }
}
</style>
